// src/pages/Errors/NotFound.tsx
import { HomeIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Heading, Text } from '@radix-ui/themes';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Flex align="center" justify="center" py="8" px="4">
            <Card size="3" variant="surface" style={{ maxWidth: '480px', width: '100%' }}>
                <Flex direction="column" align="center" gap="4" py="4" px="2">
                    <Flex
                        align="center"
                        justify="center"
                        style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: 'var(--radius-4)',
                            backgroundColor: 'var(--gray-3)',
                            color: 'var(--gray-9)',
                        }}
                    >
                        <MagnifyingGlassIcon width="28" height="28" />
                    </Flex>

                    <Flex direction="column" align="center" gap="2">
                        <Text size="2" color="gray" weight="medium">Erro 404</Text>
                        <Heading size="5" align="center">Página não encontrada</Heading>
                        <Text size="2" color="gray" align="center">
                            Lamentamos, mas a página que procura não existe ou foi movida.
                        </Text>
                    </Flex>

                    <Button type="button" onClick={() => navigate('/')}>
                        <HomeIcon /> Voltar ao painel
                    </Button>
                </Flex>
            </Card>
        </Flex>
    );
};

export default NotFound;
